// Small date helpers shared by the contacts table and the contact detail.
// Both take unix timestamps in seconds (what the API returns) and the
// current vue-i18n locale, so "hace 4 min" / "4 min ago" follow the UI
// language without extra dependencies.

export const relativeTime = (timestamp, locale) => {
  if (!timestamp) return '';
  const diff = Math.round(timestamp - Date.now() / 1000);
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  if (abs < 60) return rtf.format(diff, 'second');
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour');
  if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), 'day');
  return rtf.format(Math.round(diff / (86400 * 30)), 'month');
};

// "12 mar 2024"
export const shortDate = (timestamp, locale) =>
  timestamp
    ? new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }).format(new Date(timestamp * 1000))
    : '';

// "12 jun 2026 · 09:41"
export const shortDateTime = (timestamp, locale) => {
  if (!timestamp) return '';
  const date = new Date(timestamp * 1000);
  const day = shortDate(timestamp, locale);
  const time = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
  return `${day} · ${time}`;
};
